import React, { useState , useEffect , useContext } from "react";
import { Box, Card, Grid, Chip , CircularProgress } from "@mui/material";
import ApiService from "../../functions/apiService";
import UserSettingsHeader from "../../components/HeadersNav/userSettingsHeader";
import AuthContext from "../../context/AuthContext";
import CollapseComponent from "../../components/Schedule/CollapseComponent";
import moment from "moment";

const MemberLog = () => {
    const [overTimeData , setOverTimeData] = useState([]);
    const { user } = useContext(AuthContext);
    const [loading , setLoading] = useState(false);

    const columnsOverTime = [
        {
          field: "Shift_Date",
          headerName: "Shift Date",
          flex: 1,
          maxWidth:100,
          minWidth:100,
          renderCell: (params) => {
            return moment(params.value).format('MM/DD/YYYY');
          },
        },
        {
          field: "ResponseName",
          headerName: "Status",
          flex: 1,
          minWidth: 140,
          renderCell: (params) => {
            return (
              <Chip style={{ width: "90%" , fontSize:'12px'}} label={params.row.ResponseName} />
            );
          },
        },
        { field: "ShiftDescription", headerName: "Shift", flex: 1, minWidth: 140 , 
          renderCell: (params) => {
            return (
              <Chip style={{ width: "90%" , fontSize:'12px' , backgroundColor:'rgba(52, 152, 219, 0.16)' , border:'1px solid rgba(52, 152, 219, 0.2)' }} label={params.row.ShiftDescription} />
            );
          },
        },
        { field: "Hours", headerName: "Hours", flex: 1, minWidth: 60 , maxWidth:60 },
        {
          field: "totalHours",
          headerName: "Total Hours",
          flex: 1,
          minWidth: 100,
          maxWidth: 100
        },
        { field: "fullName", headerName: "User", flex: 1, minWidth: 220 },
        { field: "FormattedLogTime", headerName: "Time Stamp", flex: 1, minWidth: 160 },
    ];

    const memberData = () => {
        setLoading(true)
        ApiService.get("/getEmployeeLogOvertime/" + user.Emp_Code).then(({ data }) => {
            setOverTimeData(data.overTime || [])
            setLoading(false)
        }).catch(() => {
            setLoading(false)
        })
    }

    useEffect(()=>{
        memberData()
    }, [])


    return (
        <>
            <UserSettingsHeader />
            {
                loading ?
                <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
                    <CircularProgress />
                </Box> :
                <Box className='px-4' sx={{backgroundColor:'#ffffff'}}>
                    <p style={{ fontSize: '22px', fontWeight: '600', marginTop: '20px', paddingTop:'20px' }}>
                        Overtime Lists
                    </p>
                    {overTimeData && Object.entries(overTimeData).length > 0 ? (
                        <div>
                        {Object.entries(overTimeData).map(([key, value]) => (
                            <CollapseComponent
                                key={key}
                                name={key}
                                rows={value}
                                columns={columnsOverTime}
                                checkboxSelection={false}
                                hideFooter={true}
                                open={true}
                            />
                        ))}
                        </div>
                    ) : (
                        <div
                        className='d-flex flex-column align-items-center justify-content-center'
                            style={{ height: 460, width: '100%' }}
                            >
                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                            <span className='mt-4' style={{ color: '#555555' }}>
                                No Overtime Lists
                            </span>
                        </div>
                    )}
                </Box>
            }
        </>
    )
}
export default MemberLog